
import { useState } from "react";
import { validateField } from "utils/validation";

const useFormChange = (initialValues = {}, validationRules = {}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  /* =======================
     BASIC FIELD CHANGE
  ======================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (validationRules?.[name]) {
      const errorMsg = validateField(name, value, validationRules);
      setErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
    }
  };

  /* =======================
     REPEATABLE FIELD CHANGE
     (education / experience)
  ======================== */
  const handleArrayChange = (section, index, field, value) => {
    // update values
    setValues((prev) => {
      const data = [...prev[section]];
      data[index] = { ...data[index], [field]: value };
      return { ...prev, [section]: data };
    });

    // validate field
    if (validationRules?.[section]?.[field]) {
      const fieldRules = validationRules[section][field];
      // Only validate if fieldRules is an array
      if (Array.isArray(fieldRules)) {
        const errorMsg = validateField(field, value, validationRules[section]);

        setErrors((prev) => {
          const sectionErrors = prev[section] ? [...prev[section]] : [];

          sectionErrors[index] = {
            ...(sectionErrors[index] || {}),
            [field]: errorMsg,
          };

          // clean only the field
          if (!errorMsg) {
            delete sectionErrors[index][field];
          }

          return {
            ...prev,
            [section]: sectionErrors.filter(Boolean), // FILTER
          };
        });
      }
    }
  };

  /* =======================
     FILE HANDLER
  ======================== */
  const handleFileChange = (e) => {
    const { name, files, multiple } = e.target;
    if (!files || files.length === 0) return;

    const previewKey = `${name}Preview`;

    if (multiple) {
      const fileArray = Array.from(files);
      setValues((prev) => ({
        ...prev,
        [name]: fileArray,
        [previewKey]: fileArray.map((f) => URL.createObjectURL(f)),
      }));
      return;
    }

    setValues((prev) => ({
      ...prev,
      [name]: files[0],
      [previewKey]: URL.createObjectURL(files[0]),
    }));
  };

  return {
    values,
    errors,
    handleChange,
    handleArrayChange, // ✅ NEW
    handleFileChange,
    setValues,
    setErrors,
  };
};

export default useFormChange;
